import React from 'react';
import Radium from 'radium';
import StyleDecorator from './StyleDecorator';
import Theme from '../styles/theme';
import RenderIf from './RenderIf';


export class FormWrapper extends React.Component {

	static propTypes = {
		children: React.PropTypes.node.isRequired,
		header: React.PropTypes.node.isRequired,
		footer: React.PropTypes.node.isRequired,
		mediaQueries: React.PropTypes.object.isRequired,
		preBody: React.PropTypes.node,
	};

	getStyle() {
		const MediaQueries = this.props.mediaQueries;
		return {
			outerWrapper: {
				textAlign: 'center',
				width: (MediaQueries.isMaxSmallDevice()) ? '100%' : '420px',
				height: (MediaQueries.isMaxSmallDevice()) ? '100vh' : 'auto',
				marginTop: (MediaQueries.isMaxSmallDevice()) ? '0' : '1em',
				marginLeft: 'auto',
				marginBottom: (MediaQueries.isMaxSmallDevice()) ? '0' : '1em',
				marginRight: 'auto',
			},
			innerWrapper: {
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				minHeight: (MediaQueries.isMaxSmallDevice()) ? '100vh' : 'auto',
			},
			header: {
				width: '100%',
				alignSelf: 'flex-start',
			},
			main: {
				display: 'flex',
				flexDirection: 'column',
				alignItem: 'center',
				flexGrow: 1,
				flexShrink: 0,
				backgroundColor: Theme.palette.primary2Color,
			},
			body: {
				width: '100%',
				display: 'flex',
				alignSelf: 'center',
				flexDirection: 'column',
				justifyContent: 'center',
				flexGrow: 1,
				flexShrink: 0,
				paddingTop: (MediaQueries.isMaxSmallDevice()) ? '25px' : '35px',
				paddingRight: (MediaQueries.isMaxSmallDevice()) ? '25px' : '60px',
				paddingLeft: (MediaQueries.isMaxSmallDevice()) ? '25px' : '60px',
				paddingBottom: 0,
			},
			footer: {
				width: '100%',
				alignSelf: 'flex-end',
				paddingTop: 0,
				paddingRight: (MediaQueries.isMaxSmallDevice()) ? '25px' : '60px',
				paddingLeft: (MediaQueries.isMaxSmallDevice()) ? '25px' : '60px',
				paddingBottom: (MediaQueries.isMaxSmallDevice()) ? '25px' : '25px',
			},
		};
	}

	render() {
		const style = this.getStyle();
		return (
			<div style={style.outerWrapper}>
				<div style={style.innerWrapper}>
					<div style={style.header}>
						{this.props.header}
					</div>
					<div style={style.main}>
						<RenderIf exists={this.props.preBody}>
							{this.props.preBody}
						</RenderIf>
						<div style={style.body}>
							{this.props.children}
						</div>
						<div style={style.footer}>
							{this.props.footer}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default StyleDecorator(Radium(FormWrapper));



// WEBPACK FOOTER //
// ./src/components/Card.js